import '~/js/modules/bootstrap-tabs';
import countryPhoneCodes from '~/js/modules/country-phone-codes';

// create new array for countries and appending a new object that represents default value
const countries = [
  {
    name: 'Select a Country',
    id: '',
    regionCode: '',
    code: ''
  },
  ...window.beaches_app.page.countries
];

// create new array for states and appending a new object that represents default value
const states = [
  ...window.beaches_app.page.states
];

const beachesResorts = window.beaches_app.page.resorts;

// react form elements contact
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import CustomTextarea from '~/js/components/form-controls/CustomTextarea';
import DepartmentSelect from '~/js/components/general/DepartmentSelect';

ReactDOM.render(
  <CountryStateSelector
    countries={ countries }
    states={ states }
    countryName="country"
    stateName="state"
    stateLabelWrapper="lg-4"
    stateInputWrapper="lg-8"
    countryLabelWrapper="lg-4"
    countryInputWrapper="lg-8"
  />,
  document.getElementById('country-state-selector')
);

ReactDOM.render(
  <CustomDatePicker
    name="weddingDate"
    wrapperClassName="xs-12"
    inputClassName="hidden-validation wedding-date-input"
    displayStringDate={false}
    isRequired
  />,
  document.getElementById('wedding-datepicker')
);

ReactDOM.render(
  <CustomTextarea
    name="message"
    id="message"
    maxLength="4000"
    displayCharacterCount
    isRequired
  />,
  document.getElementById('react-textarea')
);

ReactDOM.render(
  <CustomRecaptcha
    wrapperClassName="xs-12"
  />,
  document.getElementById('google-recaptcha')
);

ReactDOM.render(
  <DepartmentSelect
    resorts={ beachesResorts }
  />,
  document.getElementById('department-dropdown')
);

// form validations
import '~/js/modules/fend';

// Form Validation
$('.contact-form').fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    city: 'lettersOnly'
  }
});

// form elements references
const $weddingDateRow = $('.wedding-date-row');
const $weddingDateInput = $('.wedding-date-input');
const $countrySelector = $('select[name="country"]');
const $tabContainer = $('#desktop-tabs');
const $tabSelector = $('#js-tab-select');
const $landlineNumber = $('#landLineNumber');
const $mobileNumber = $('#mobileNumber');

// select functionality
$tabSelector.change( function toggleTabs() {
  $('.tab-pane').hide();
  $('#' + $(this).val()).show();
  $('.active').removeClass('active');
  $('#' + $(this).val()).addClass('active');
  $('#tab-' + $(this).val()).addClass('active');
  $('.tab-' + $(this).val()).addClass('active');
});

$tabContainer.on('click', '.tab', (event) => {
  const $tabValue = $(event.currentTarget).find('.tab-link').data('value');

  $tabSelector.val($tabValue);
  $tabSelector.trigger('change');
});

// mobile number validation at least one must be required
$landlineNumber.change( function validateNumber() {
  if (this.value) {
    $mobileNumber.removeAttr('required');
    $mobileNumber.trigger( 'blur' );
  }else {
    $mobileNumber.attr('required', true);
  }
});

$mobileNumber.change( function validateNumber() {
  if (this.value) {
    $landlineNumber.removeAttr('required');
    $landlineNumber.trigger( 'blur' );
  }else {
    $landlineNumber.attr('required', true);
  }
});

// Hide Time Zone when Best Time To Call Select is on Don't Call
$('#bestTimeToCall').on('change', (event) =>{
  const selectedValue = event.target.value;

  if(selectedValue === 'dont') {
    $('#timezone').removeAttr('required');
    $('#timezone').prop('disabled', true);
    $('#timezone').val('');
    $('#timezone-error').hide();
  } else {
    $('#timezone').prop('required', true);
    $('#timezone').removeAttr('disabled');
  }

})

// display wedding date
$('[name="planningWedding"]').on('change', (event) =>  {
  const $selectedValue = event.target.value;

  if ($selectedValue === 'true') {
    $weddingDateRow.slideDown('fast');
    $weddingDateInput.removeClass('hidden-validation');
  } else {
    $weddingDateRow.slideUp('fast');
    $weddingDateInput.addClass('hidden-validation');
  }
});

$(document).ready( () => {
  if ($landlineNumber.val()) {
    $mobileNumber.removeAttr('required');
    $mobileNumber.trigger( 'blur' );
  }

  if ($mobileNumber.val()) {
    $landlineNumber.removeAttr('required');
    $landlineNumber.trigger( 'blur' );
  }

  //FOR COUNTRY CODE
  $('[name=country]').on('change', function() {
    const selectedCountry = $(this).val();
    const phoneCode = countryPhoneCodes.find((obj) => obj.code === selectedCountry).dial_code;

    $('span.countryCode').html(phoneCode);
  });

  if(window.location.hash) {
    const hash = window.location.hash.substring(1);

    Array.prototype.forEach.call($tabSelector.get(0).options, (option) => {
      if(option.value === hash) {
        $tabSelector.val(hash);
        $tabSelector.trigger('change');
      }
    });
  }
});

document.getElementById('wantToBeCalled').onchange = (e) => {
  const contactInfo = document.getElementById('contact-info');

  if(e.target.value === 'true') {
    contactInfo.style.maxHeight = contactInfo.scrollHeight + 'px';
    $('#timezone').prop('required', true);
    $('#bestTimeToCall').prop('required', true);
    $('#department').prop('required', true);
    $('#phoneNumber').prop('required', true);
    $('#subscribeSms').prop('required', true);
  } else {
    contactInfo.style.maxHeight = null;
    $('#wantToBeCalled').removeAttr('required');
    $('#bestTimeToCall').removeAttr('required');
    $('#department').removeAttr('required');
    $('#phoneNumber').removeAttr('required');
    $('#subscribeSms').removeAttr('required');
  }
};

// SMS opt-in
const smsProp = document.querySelector(".sms");
const countryInput = document.querySelector("#gcvCountryFieldId");
const smsCheckBox = document.querySelector("#subscribeSms");

countryInput.addEventListener("change", function(event){

  if(event.target.value === "US"){
    smsProp.classList.remove("hideSms");
    smsProp.classList.add("showSms");
  }
  else if(event.target.value !== "US"){
    smsProp.classList.add("hideSms");
    smsProp.classList.remove("showSms");

    if(smsCheckBox.checked===true){
      smsCheckBox.checked = false;
    }
  }
});
